import React from "react";
import {
  Flex,
  Button,
  Icon,
} from "@chakra-ui/react";
import { BsFillArrowUpCircleFill } from "react-icons/bs";
import AutoResizeTextarea from "../chat/AutoSize";

const Footer = ({
  shouldScroll,
  inputMessage,
  setInputMessage,
  handleSendMessage,
}) => {
  return (
    <Flex w="100%" justify="center">
      <Flex w="80%" mt="5" mb="1rem">
        <AutoResizeTextarea
          size="lg"
          disabled={shouldScroll === true}
          placeholder={shouldScroll === true ? "Robin is thinking!" : "Ask Anything..."}
          border="1px solid gray"
          borderRadius="10px"
          _focus={{
            border: "1px solid #6f55ff",
          }}
          onKeyPress={(e) => {
            if (e.key === "Enter" && e.shiftKey) {
              setInputMessage(e.target.value + "\n");
            } else if (e.key === "Enter") {
              e.preventDefault();
              handleSendMessage();
            }
          }}
          value={inputMessage}
          onChange={(e) => setInputMessage(e.target.value)}
        />
        <Button
          bg="transparent"
          borderRadius="10px"
          disabled={inputMessage.trim().length <= 0}
          onClick={handleSendMessage}
          margin="auto"
          isLoading={shouldScroll === true}
        >
          <Icon
            as={BsFillArrowUpCircleFill}
            color="#ff415e"
            backgroundColor="none"
            boxSize="8"
          ></Icon>
        </Button>
      </Flex>
    </Flex>
  );
};

export default Footer;
